import { connect } from "react-redux";
import { withRouter } from "react-router";
import { getValueFromQuery } from "common/filter/utils";
import { TYPE_CHECKBOXES } from "common/filter/constants";
import Tag from "common/filter/components/tag";

export const mapStateToProps = (state, { resourceName, field, location }) => {
  return {
    value: getValueFromQuery(
      resourceName,
      field,
      TYPE_CHECKBOXES,
      location.query
    ),
  };
};

export default withRouter(connect(mapStateToProps)(Tag));
